
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Multiple_myeloma",
components: {
XTable
}
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Multiple_myeloma.vue